/*

 +-++-++-++-++-++-++-++-++-++-++-++-++-+
 |Q||u||a||r||t||e||r||M||a||s||t||e||r|
 +-++-++-++-++-++-++-++-++-++-++-++-++-+

 2016-2017 Quartermaster

 Track QM-APP state. active/inactive and background

 Can be 'active','background','inactive'

 */
import QM_API from '@quartermaster/qmlib-api';
import constants from '../constants/index';
import { errorInterceptor } from './ErrorHandler';
import { dataInterceptor } from './QMDataService';
import { rewardInterceptor } from './QMRewardService';
import { Headers } from './APIConstants';
import { store } from '../redux';
import { selectAuthJWT } from '../redux/auth/selectors';
import { selectMe } from '../redux/me/selectors';

const API = new QM_API(
  {
    ...constants.WORKING_CONFIG,
    TIMEOUT: constants.DEFAULT_API_TIMEOUT,
  },
  { headers: Headers },
  [errorInterceptor, dataInterceptor, rewardInterceptor],
);

export const getUserAPI = config => {
  const apiConfig = {
    ...constants.WORKING_CONFIG,
    TIMEOUT: constants.DEFAULT_API_TIMEOUT,
    is_mobile: false,
    platform: 'web',
  };

  const currentStoreState = store.getState();

  const me = selectMe(currentStoreState);
  const JWT = selectAuthJWT(currentStoreState);

  if (JWT) {
    apiConfig.TOKEN = JWT;
  }

  if (me) {
    if (me.properties && me.properties.length) {
      apiConfig.TYPE = 'PROPERTY';
      apiConfig.PROPERTY_ID = me.properties[0].id;
    } else if (me.businesses && me.businesses.length) {
      apiConfig.TYPE = 'BUSINESS';
      apiConfig.BUSINESS_ID = me.businesses[0].id;
    }
  }

  return new QM_API({ ...apiConfig, ...config });
};

if (global) global.API = API;

export default API;
